var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcChalet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54.98 43.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: currentColor;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.96,21.29c-1.22-.52-1.29-1.49-.14-2.16L31.86.99c1.15-.67,3.17-1.11,4.49-.97l4.83.5c1.32.14,2.85,1.24,3.4,2.45l10.06,22.21c.55,1.21.41,1.28-.3.16l-12.46-19.65c-.73-1.13-2.21-1.48-3.37-.81L8.83,22.5c-1.14.68-3.08.81-4.31.29l-3.56-1.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.94,15.7c-1.13.7-2.51,2.26-3.06,3.47l-10.21,22.49c-.55,1.21.09,2.2,1.42,2.2h28.35c1.33-.01,2.79-1.03,3.25-2.28l6.66-18.21c.46-1.25.25-3.19-.45-4.32l-7.48-11.9c-.72-1.13-2.2-1.47-3.34-.78l-15.13,9.33Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.48,41.67c-.56,1.21-2.1,2.2-3.43,2.2h-3.02c-1.33,0-1.94-.98-1.36-2.17l7.91-16.32c.58-1.2,1.99-2.73,3.13-3.41l5.95-3.53c1.14-.68,1.62-.25,1.07.96l-10.26,22.28Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChalet);
export default __webpack_public_path__ + "static/media/ic_chalet.c36ad14de64d22ff0005fe2c53ffcf73.svg";
export { ForwardRef as ReactComponent };